import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";
import { $getSelection } from "lexical";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { $isDesignHuddleNode } from "../../nodes/design-huddle-node";
import { $isPollNode } from "../../nodes/poll/helpers";
import { DESIGN_HUDDLE_EDIT_COMMAND, OPEN_EDIT_POLL_COMMAND } from "../../types/commands";
import { floatingToolbarStyles } from "./floating-toolbar-styles";
import type { ToolbarProps } from "./props";

export const EditButton: FC<ToolbarProps> = ({ disabled, mode = "toolbar" }) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  const onClick = useCallback(() => {
    editor.getEditorState().read(() => {
      const selection = $getSelection();
      const node = selection?.getNodes()[0];
      if ($isDesignHuddleNode(node)) {
        editor.dispatchCommand(DESIGN_HUDDLE_EDIT_COMMAND, {
          nodeKey: node.getKey(),
        });
      }

      if ($isPollNode(node)) {
        editor.dispatchCommand(OPEN_EDIT_POLL_COMMAND, { nodeKey: node.getKey() });
      }
    });
  }, [editor]);

  return (
    <Tooltip title={t("Edit")}>
      <IconButton
        data-analytics-id={`lexical-${mode}-edit-node`}
        disabled={disabled}
        data-testid={`${mode}-button-edit-node`}
        aria-label="Edit"
        tabIndex={-1}
        sx={{
          ...floatingToolbarStyles[mode].button,
          backgroundColor: "background.neutral",
        }}
        onClick={onClick}
      >
        <EditIcon sx={floatingToolbarStyles[mode].formatIcon} />
      </IconButton>
    </Tooltip>
  );
};
